import { DrillCode, resolveDrillCode } from "../../domain/drill-code";
import { ListDrillsUseCase } from "./list-drills.usecase";

export class ResolveDrillCodeUseCase {
    static async execute(drillId?: string): Promise<DrillCode> {
        if (!drillId) return DrillCode.COLOR_DASH;
        const drills = await ListDrillsUseCase.execute();
        const drill = drills.find((item) => item.id === drillId);
        return resolveDrillCode(drill?.code);
    }
}
